import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { signOut, tenantChange, instanceChange } from "./authSlice";
import { TableColumn, DropdownOption, AudiencePreviewData } from "@/types";

export interface ITableColumn {
  data?: string;
  fieldName?: string;
  isMultiline?: boolean;
  isResizable?: boolean;
  key: string;
  maxWidth?: number;
  minWidth?: number;
  name?: string;
}

export interface IAudiencePreviewConfig {
  options: DropdownOption[];
  audienceName: string;
  data: AudiencePreviewData | null;
  columnData: TableColumn[];
}

export interface TableState {
  audiencePreviewConfig: IAudiencePreviewConfig[];
}

const initialState: TableState = {
  audiencePreviewConfig: [],
};

interface SaveAudiencePreviewConfigPayload {
  audienceName: string;
  data?: AudiencePreviewData;
  columnData?: TableColumn[];
  options?: DropdownOption[];
}

const tableSlice = createSlice({
  name: "table",
  initialState,
  reducers: {
    saveAudiencePreviewConfig: (state, action: PayloadAction<SaveAudiencePreviewConfigPayload>) => {
      const { audienceName, data, columnData, options } = action.payload;
      const foundItem = state.audiencePreviewConfig.find(
        (item) => item.audienceName === audienceName,
      );

      if (foundItem) {
        if (data) {
          foundItem.data = data;
        }
        if (columnData) {
          foundItem.columnData = columnData;
        }
        if (options) {
          foundItem.options = options;
        }
      } else {
        state.audiencePreviewConfig.push({
          audienceName,
          data: data || null,
          columnData: columnData || [],
          options: options || [],
        });
      }
    },
    clearAudiencePreviewConfig: (state, action: PayloadAction<{ audienceName: string }>) => {
      state.audiencePreviewConfig = state.audiencePreviewConfig.filter(
        (item) => item.audienceName !== action.payload.audienceName,
      );
    },
    clearAllAudiencePreviewConfigs: (state) => {
      state.audiencePreviewConfig = [];
    },
    resetTableState: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(signOut, () => initialState)
      .addCase(tenantChange, () => initialState)
      .addCase(instanceChange, () => initialState);
  },
});

export const {
  saveAudiencePreviewConfig,
  clearAudiencePreviewConfig,
  clearAllAudiencePreviewConfigs,
  resetTableState,
} = tableSlice.actions;

export default tableSlice.reducer;
